import { useEffect, useState } from 'react';
import { getJobRevenue, IJobRevenue } from 'wisestep-api';

const useJobRevenue = (jobId: string) => {
  const [jobRevenue, setJobRevenue] = useState<IJobRevenue | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!jobId) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getJobRevenue(jobId);
        setJobRevenue(response.data);
      } catch (err: any) {
        console.error('Failed to fetch job revenue', err);
        setError(err?.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [jobId]);

  return { jobRevenue, loading, error };
};

export default useJobRevenue;
